import React from "react";
import { Route } from "react-router-dom";

export const CmsRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => <Component {...props} />} />
  );
};
